export enum LevelType {
  'USER' = 'USER',
  'OFFICE' = 'OFFICE',
}
